import { fetchApiData } from "../../utils/utils"

export const getLiveInfo = async (appInfo)=>{
    // const api="channel/list"
    const api=`fastchannel/${appInfo?.projectDetails?.projectConfig?.config?.FAST_CHANNEL_ID}`
    return await fetchApiData(appInfo,api)
  }

  export const getEventInfo = async (appInfo,eventId)=>{
    const api=`event/${eventId}`
    return await fetchApiData(appInfo,api)
  }

  export const getLiveSchedule = async (appInfo) => {
    const channelId = appInfo?.projectDetails?.projectConfig?.config?.FAST_CHANNEL_ID;
    const api = `schedule/guide/${channelId}?channel_id=${channelId}`;
    return await fetchApiData(appInfo, api);
  };